<a
  class="employee-card no-drag"
  [routerLink]="isTrainingEmployees || utils.isDesktop ? null : employeeUrl"
>
  <div
    class="employee-card__avatar"
    [class.image-border]="employee?.avatar?.previewNormal === null"
  >
    <app-image [img]="employee?.avatar?.previewNormal | addBaseUrl"></app-image>
  </div>
  <div class="employee-card__info">
    <div class="employee-card__info-name">
      <a
        [routerLink]="isTrainingEmployees || !utils.isDesktop ? null : employeeUrl"
        class="nav-link employee-card__info-name-link"
      >
        @if (employee?.dateEmployment | yearsOfServiceBadgeIcon; as badgeIcon) {
          <app-svg [icon]="badgeIcon" class="employee-card__years_of_service_badge"></app-svg>
        }
        <app-text
          [textSize]="TextSizes.h4Name"
          [textType]="TextType.base"
          [text]="employee | getFullName"
        ></app-text>
        @if (employee?.isDirector) {
          <img src="/assets/images/icons-svg/director.svg" />
        }
      </a>
      @if (employee && employee.state) {
        <div class="employee-card__info-status">
          <app-text
            [text]="employee.state"
            [textType]="TextType.base"
            [textSize]="TextSizes.alert"
          ></app-text>
        </div>
      }
    </div>
    <div class="employee-card__info-position">
      <app-text
        [textSize]="TextSizes.mobPost"
        [textType]="TextType.base"
        [text]="employee?.userPosition?.name"
      ></app-text>
    </div>
    @if (isShowDepartment) {
      <div class="employee-card__info-department">
        <app-text
          [textSize]="TextSizes.h5Post"
          [textType]="TextType.base"
          class="employee-card__info-department__text"
          [text]="
            employee?.userDepartment?.type === departmentsType.shop
              ? [employee?.userDepartment?.name, employee?.userDepartment?.city?.name].join(' · ')
              : employee?.userDepartment?.name
          "
        ></app-text>
      </div>
    }
    @if (!isTrainingEmployees) {
      <div class="employee-card__info-userData user-select-text">
        @if (employee?.email) {
          <a
            href="mailto:{{ employee?.email }}"
            class="employee-card__info-userData-item"
            (click)="onEmailClick($event)"
          >
            <app-svg icon="email"></app-svg>
            <app-text
              [textSize]="TextSizes.mobInput"
              [textType]="TextType.base"
              [text]="employee?.email"
              [canCopy]="true"
            ></app-text>
          </a>
        }
        <app-contacts [email]="employee?.email"></app-contacts>
      </div>
    }
  </div>
</a>
